import { brandColor } from '@/styles/constant'

/**
 * エラー発生時のフォールバックコンポーネント
 * カスタムフックなど利用しない簡素な構成でok
 */
export function ErrorFallback() {
  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>
        申し訳ございません。エラーが発生しました。
      </h2>
      <p style={{ marginBottom: '20px', color: '#6c757d' }}>
        システムエラーが発生しました。しばらく時間をおいてから再度お試しください。
      </p>
      <button
        onClick={() => {
          window.location.href = '/'
        }}
        style={{
          padding: '10px 20px',
          backgroundColor: brandColor,
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        トップへ戻る
      </button>
    </div>
  )
}
